<template>
    <div v-show="show" class="relative pointer-events-auto rounded-md shadow-md border-2 p-4 mt-6 mx-auto w-full sm:w-2/3 xl:w-3/5"
        :class="alert_class"
        role="alert"
    >
        <button type="button"
            aria-label="close"
            class="absolute top-0 right-0 leading-none px-2 py-1 cursor-pointer focus:outline-none focus:shadow-none select-none text-2xl text-gray-600 hover:text-gray-800"
            @click="show = false"
        >
            <span aria-hidden="true">&times;</span>
        </button>

        <ul class="font-semibold">
            <li v-for="message in messages">
                {{ message }}
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props: {
        messages: {},
        type: {},
    },

    data() {
        return {
            show: true,
        }
    },

    computed: {
        alert_class() {
            switch(this.type) {
                case 'error':
                    return 'border-red-400 bg-red-200 text-red-700';
                default:
                    return 'border-green-300 bg-green-100 text-green-600';
            }
        },
    },

}
</script>

